export default
    {
        // 会员补充信息
        async upgradeMemberInfo(params) {
            let actiontype = 'upgradeMemberInfo';
            return await this.fetch(actiontype, params);
        },
        // 我的积分等级信息
        async getMyIntegralInfo(params, type) {
            let actiontype = 'getMyIntegralInfo';
            if (!type) {
            	type = false;
            }
            return await this.fetch(actiontype, params, type);
        },
        // 获取证件列表  
        async getIdManaList(params) {
            let actiontype = 'AccountService_UserDetailInfoHandler';
            return await this.fetch(actiontype, params);
        },
        // 添加用户证件信息
        async addPassengerIdInfo(params) {
            let actiontype = 'addPassengerIdInfo';
            return await this.fetch(actiontype, params);
        },
        // 修改用户信息
        async modifyPsgInfo(params) {
            let actiontype = 'modifyPassengerInfo';
            return await this.fetch(actiontype, params);
        },
        // 乘机人列表查询
        async getPsgInfoList(params) {
            let actiontype = 'AccountService_FrequentFlierListHandler';
            return await this.fetch(actiontype, params);
        },
        // 变更受益人或乘机人
        async editPsgInfo(params) {
            let actiontype = 'gralEnrichedFrequentModify';
            return await this.fetch(actiontype, params);
        },
        // 删除受让人或乘机人  
        async deletPsgInfo(params) {
            let actiontype = 'gralEnrichedFrequentDelete';
            return await this.fetch(actiontype, params);
        },
        // 查询受让人列表  
        async getTransList(params) {
            let actiontype = 'getGralEnrichedFrequentList';
            return await this.fetch(actiontype, params);
        },
        // 新增受让人  
        async addTransInfo(params) {
            let actiontype = 'gralEnrichedFrequentAdd';
            return await this.fetch(actiontype, params);
        },
        // 获取签发国  
        async getCountryList(params) {
            let actiontype = 'FlightService_GetAllCountryInfo';
            return await this.fetch(actiontype, params);
        },
        // 旅客积分补登
        async flyRecordMakeUp(params) {
            let actiontype = 'flyRecordMakeUp';
            return await this.fetch(actiontype, params);
        },
        // 积分明细
        async getMyIntegralDetail(params) {
            let actiontype = 'getMyIntegralDetail';
            return await this.fetch(actiontype, params);
        },
        // 完善会员信息 
        async upgradeMemberInfo(params) {
            let actiontype = 'upgradeMemberInfo';
            return await this.fetch(actiontype, params);
        },
        // 改期生单
        async submitChangeDateOrder2(params) {
            let actiontype = 'OrderService_TicketChangeHandler';
            return await this.fetch(actiontype, params);
        },
        // 新航班查询
        async newSearchFlight(params) {
            let actiontype = 'searchConnectFlights';
            return await this.fetch(actiontype, params);
        },
        // 龙腾休息室加密接口
        async dragonPassH5(params) {
            let actiontype = 'dataEncrypt';
            return await this.fetch(actiontype, params);
        },
        // SeatChoose_GetTravelSegmentInfoBySaleOrderId
        async getTravelSegmentInfo(params) {
            let actiontype = 'SeatChoose_GetTravelSegmentInfoBySaleOrderId';
            return await this.fetch(actiontype, params);
        },
        // 大客户编码验证
        async cusomerCodeValidate(params) {
            let actiontype = 'bigcustomer_cusomerCodeValidate';
            return await this.fetch(actiontype, params);
        },
    }



// WEBPACK FOOTER //
// ./src/interfaces/modules/vip.js